import React from 'react';
//import {Link} from 'react-router-dom';
import './UserChatEntry.css'
import { fullCountryName, prepareLastActiveText } from '../helpers/functions';
import close from '../static/vectors/close.svg';
import envelope from '../static/vectors/envelope.svg';
import diamond from '../static/vectors/gem-black.svg';
import mask from '../static/images/host-icon.png';
import redMask from '../static/images/host-icon-red.png';
import USER_STATUSES from '../constants/userStatuses';

const UserChatEntry = ({ user, onClick = null, onDeleteRoom = null, unread = false, disabled = true }) => {
  return (
    <div
      className="row user-chat-entry"
      onClick={() => {onClick()}}
    >
      <div className="photo" style={ {backgroundImage: `url('${user.photo_url}')`} }/>
      <div className="texts">
        {user.refCode && user.refCode.length > 0 && user.refCode !== 'disabled' && user.refCode !== 'pending' &&
        <div className="host">
          <img src={mask} alt={"mask"} />
        </div>}
        {user.elite === 1 &&
        <div className="host">
          <img src={redMask} alt={"mask"} />
        </div>}
        {user.status >= USER_STATUSES.superior &&
        <div className="superior">
          <img src={diamond} alt={"diamond"} />
        </div>}
        <div className="name">{user.name}</div>
        <div className="last-active">{prepareLastActiveText(user.last_active)}</div>
        <div className="location">{`${user.city}, ${fullCountryName(user.country)}`}</div>
        <div className="message">
          Click to read
        </div>
      </div>
      <button
        onClick={(e) => {e.stopPropagation(); onDeleteRoom();}}
        className="btn delete"
      >
        <img src={close} alt="eye crossed" />
      </button>
      {unread && <div
        className="envelope"
      >
        <img src={envelope} alt="envelope" />
      </div>}
    </div>
  )
}

export default UserChatEntry;


// WEBPACK FOOTER //
// ./src/components/UserChatEntry.js